import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import { LockedAccountList } from './components/AccountAndLoan'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./AccountsAndLoans.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class LockedAccountsView extends React.Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired, 
    deleteLockedAccount: PropTypes.func.isRequired,
    openLockedAccountForm: PropTypes.func.isRequired,
  }

  render() {
    const { accountsAndLoans, deleteLockedAccount, openLockedAccountForm } = this.props
    if (accountsAndLoans.isFetching) {
      return (<Loading pageLoading />)
    }

    return (
      <div className={styles.content}>
        <section className={styles.section}>
          {accountsAndLoans.fetched && accountsAndLoans.lockedAccounts &&
          <LockedAccountList
            deleteLockedAccount={deleteLockedAccount}
            header={constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.LOCKED_ACCOUNT_LABEL}
            lockedAccountItems={accountsAndLoans.lockedAccounts}
            openLockedAccountForm={openLockedAccountForm}
          />}
        </section>
      </div>
    )
  }
}

export default LockedAccountsView



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/LockedAccounts.js